import { useStore } from "@/components/common/store";
import type { SearchFormDataType } from "@/interfaces/search-form";
import { onBeforeUnmount, onBeforeMount } from "vue";
import type { MutationPayload, Store } from "vuex";



export function useSearchMaskUpdate(
	handler: () => Promise<void>,
	excludes: Array<keyof SearchFormDataType>,
	additionalMutations: Array<string> = []
) {
	const relevantMutations = ['searchMask/updateFormData', 'searchMask/updateFlex']
	const store: Store<unknown> = useStore() as Store<unknown>;
	const actualMutations = [...relevantMutations, ...additionalMutations];
	// Check if the mutation payload has the excludes, but update if more filters changes e.g: removing tag from filtertaglist
	const needUpdate = (mutation: MutationPayload) => !excludes.some((exclude) => exclude in mutation.payload) || (Object.keys(mutation.payload).length > excludes.length)

	const unsubscribe = store.subscribe(async (mutation) => {
		if (actualMutations.includes(mutation.type)) {
			if (typeof mutation.payload !== 'object' || needUpdate(mutation)) {
				await handler()
			}
		}
	})

	onBeforeMount(() => {
		handler();
	})

	onBeforeUnmount(() => {
		unsubscribe();
	})
}
